import request from '../utils/request'

export function listproduct(data) {
    return request({
        url: '/api/open/uni/listproduct?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&cate='+data.cate+'&sub_cate='+data.sub_cate+'&s_sub_cate='+data.s_sub_cate+'&keywords='+data.keywords+'&product_types='+data.product_types+'&sort_type='+data.sort_type+'&sort_value='+data.sort_value,
        method: 'get'
    })
}

export function listcate(data) {
    return request({
        url: '/api/open/uni/listcate',
        // url: '/api/open/uni/listcate?parent_id='+data.parent_id,
        method: 'get',
        params: data
    })
}

export function listCateNew(data) {
    return request({
        url: '/api/open/uni/listCateNew',
        method: 'get',
        params: data
    })
}


export function productinfo(data) {
    return request({
        url: '/api/open/uni/productinfo?id='+data.id,
        method: 'get'
    })
}

export function listremark(data){
    return request({
        url: '/api/open/uni/listremark?xcate='+data.xcate+'&xid='+data.xid+'&pageSize='+data.pageSize,
        method: 'get'
    })
}

export function orderOn(data){
    return request({
        url: '/api/orderitem/list?order_no='+data.order_no+'&product_type='+data.product_type,
        method: 'get'
    })
}

export function getExpress(data){
    console.log("getExpress--");
    console.log(data);
    return request({
        url: '/api/orderExpress/getExpress',
        method: 'post',
        data
    })
}

export function GetConfig(data){
    return request({
        url: '/api/open/uni/GetConfig',
        method: 'get'
    })
}

export function add(data){
    return request({
        url: '/api/inquiry/add',
        method: 'post',
        data
    })
}

export function getInquiryList(data){
    return request({
        url: '/api/inquiry/getInquiryList',
        method: 'get',
        params: data
    })
}

export function details(data){
    return request({
        url: '/api/inquiry/details',
        method: 'get',
        params: data
    })
}
